let types = {};

async function fetchTypes() {
    try {
        const response = await fetch('https://api.shop.actualoptic.kz/api/visit-types');
        if (!response.ok) {
            throw new Error(`Ошибка загрузки: ${response.statusText}`);
        }
        types = await response.json();
    } catch (error) {
        console.error("Ошибка при загрузке типов вита:", error);
        types = {};
    }
}

fetchTypes().then(r => {});

function getVisitTypes() {
    return types;
}

function getVisitTypesArray() {
    return Object.keys(getVisitTypes());
}

function getVisitTypeTitle(key) {
    return getVisitTypes()[key]?.title || null;
}

export {
    getVisitTypes,
    getVisitTypesArray,
    getVisitTypeTitle
};
